<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1>{{ $t('Documentos') }}</h1>
          </v-card-title>
          <v-card-text>
            <document-list
              :key="docuKey"
              :paginationInSearch="true"
              :add-select-checkbox="true"
              two-line
              @newDocumentClicked="showDocumentForm = true"
              admin-actions
              v-if="searchConfigReady"
              entity="document"
              :reload="reload"
              @entitiesloaded="entitiesLoaded()"
              :level="1"
              search-input
              :search-config="searchConfig"
              default-icon="mdi-file-document-outline"
            ></document-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showDocumentForm" max-width="500px">
      <admin-document-form
        @closeDialog="showDocumentForm = false"
        @submit="onSubmit"
      ></admin-document-form>

      <!-- <date-menu-form  @created="addDate" @closeForm="dateForm = false" ></date-menu-form> -->
    </v-dialog>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import DocumentList from '@/modules/openbox/components/fiscal-obligations/DocumentList.vue';
import AdminDocumentForm from './AdminDocumentForm.vue';

export default {
  components: {
    DocumentList,
    AdminDocumentForm,
  },
  data() {
    return {
      currentMonth: new Date().toISOString().substr(0, 7),
      searchConfigReady: false,
      searchConfig: {},
      reload: false,
      showDocumentForm: false,
      adminDoc: {},
      docuKey: 0,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getMonthDate(month) {
      return this.year + '-' + month;
    },
    getConfig() {
      this.searchConfigReady = false;
      apiCtrl.get('/config/document').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('adminSearch')) {
          this.searchConfig = res.data.data.adminSearch;
        }
        this.searchConfigReady = true;
      });
    },
    entitiesLoaded() {
      console.log('entitiesloaded');
      this.reload = false;
    },
    onSubmit() {
      this.docuKey++;
      this.showDocumentForm = false;
    },
  },
};
</script>
